import React from 'react';
import { connect } from 'react-redux';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { AUTH_PROFILE_UPDATE_LEGACY_INFO, AUTH_SEND } from 'apps/auth/constants/UrlConstants';

const ProfileUpdatePopup = (props) => {
    const getHeader = (props) => {
        return <DangerouslyHtml dangerouslyHtml={props.profileModalText} />;
    };

    return (
        <SimplePopup popupRef={props.popupRef} text={getHeader(props)} withoutBorder={false}>
            <PopupButton
                text={props.profileModalSubmit}
                iconName="arrow-forward"
                href={AUTH_PROFILE_UPDATE_LEGACY_INFO + `?redirectUrl=${props.redirectUrl}${props.backUrl ? '&backUrl=' + props.backUrl : ''}`}
            />
        </SimplePopup>
    );
};

ProfileUpdatePopup.defaultProps = {
    redirectUrl: AUTH_SEND,
};

const mapStateToProps = (state) => {
    return {
        profileModalText: state.messages.pageMessages.profileModalText,
        profileModalSubmit: state.messages.pageMessages.profileModalSubmit,
    };
};
export default connect(mapStateToProps)(ProfileUpdatePopup);
